export const NFT_RENTAL_LOG_LIST_REQUEST = 'NFT_RENTAL_LOG_LIST_REQUEST';
